import { Icon } from 'deepstash-ui';
import React from 'react';
import { SVGProps } from 'theme/icons';

const SvgComponent: React.FC<SVGProps> = props => {
  return (
    <Icon width="47" height="24" viewBox="0 0 47 24" fill="none" {...props}>
      <rect
        x="0.000244141"
        y="6.10352e-05"
        width="46.1538"
        height="24"
        rx="7.38461"
        fill="url(#paint0_linear_1602_3040)"
      />
      <rect
        x="0.000244141"
        y="6.10352e-05"
        width="46.1538"
        height="24"
        rx="7.38461"
        fill="url(#paint1_linear_1602_3040)"
        fillOpacity="0.4"
      />
      <path
        d="M10.1175 17.7734H7.45908V7.2559H12.1446C13.1969 7.2559 14.0388 7.38329 14.6702 7.63806C15.3015 7.89283 15.7557 8.30821 16.0326 8.88421C16.3095 9.46021 16.448 10.2411 16.448 11.227C16.448 12.1574 16.3095 12.9162 16.0326 13.5033C15.7557 14.0793 15.3015 14.5057 14.6702 14.7827C14.0388 15.0596 13.1969 15.1981 12.1446 15.1981H10.1175V17.7734ZM11.7126 9.43252H10.1175V13.0214H11.7126C12.4991 13.0214 13.0252 12.8885 13.2911 12.6227C13.5569 12.3568 13.6898 11.8916 13.6898 11.227C13.6898 10.5956 13.5569 10.1414 13.2911 9.86452C13.0252 9.57652 12.4991 9.43252 11.7126 9.43252ZM20.5184 17.7734H17.8599V7.2559H22.8778C24.1959 7.2559 25.1541 7.55498 25.7522 8.15314C26.3614 8.74021 26.6661 9.60975 26.6661 10.7617C26.6661 11.6257 26.4501 12.3679 26.0181 12.9882C25.5861 13.5974 25.0156 13.9796 24.3067 14.1347L24.2901 14.1845C24.567 14.3617 24.8716 14.6553 25.2039 15.0651C25.5362 15.475 25.863 15.9236 26.1842 16.411C26.5165 16.8873 26.8101 17.3359 27.0648 17.7568V17.7734H23.9744L22.1799 15.115C22.0248 14.8824 21.8974 14.7162 21.7978 14.6165C21.7091 14.5168 21.5984 14.4559 21.4654 14.4337C21.3436 14.4116 21.1442 14.4005 20.8673 14.4005H20.5184V17.7734ZM22.4458 9.4159H20.5184V12.2405H22.4458C22.9996 12.2405 23.3818 12.1297 23.5922 11.9082C23.8138 11.6867 23.9245 11.3267 23.9245 10.8282C23.9245 10.3297 23.8138 9.96975 23.5922 9.74821C23.3818 9.52667 22.9996 9.4159 22.4458 9.4159ZM28.2367 12.5064C28.2367 11.1661 28.3863 10.1027 28.6853 9.31621C28.9955 8.52975 29.5217 7.96483 30.2638 7.62144C31.017 7.27806 32.0638 7.10637 33.4041 7.10637C34.4121 7.10637 35.2484 7.20052 35.913 7.38883C36.5776 7.57714 37.1038 7.88175 37.4915 8.30267C37.8792 8.7236 38.1506 9.28298 38.3056 9.98083C38.4718 10.6676 38.5549 11.5094 38.5549 12.5064C38.5549 13.5144 38.4718 14.3673 38.3056 15.0651C38.1506 15.7519 37.8792 16.3057 37.4915 16.7267C37.1038 17.1476 36.5776 17.4522 35.913 17.6405C35.2484 17.8288 34.4121 17.923 33.4041 17.923C32.3961 17.923 31.5598 17.8288 30.8952 17.6405C30.2306 17.4522 29.7044 17.1476 29.3167 16.7267C28.929 16.3057 28.6521 15.7519 28.486 15.0651C28.3198 14.3673 28.2367 13.5144 28.2367 12.5064ZM33.4041 15.5968C34.113 15.5968 34.6447 15.5082 34.9992 15.331C35.3536 15.1537 35.5918 14.8436 35.7136 14.4005C35.8355 13.9464 35.8964 13.315 35.8964 12.5064C35.8964 11.7088 35.8355 11.0885 35.7136 10.6454C35.5918 10.2024 35.3536 9.89221 34.9992 9.71498C34.6447 9.52667 34.113 9.43252 33.4041 9.43252C32.7063 9.43252 32.1746 9.52667 31.809 9.71498C31.4546 9.89221 31.2109 10.2024 31.078 10.6454C30.9561 11.0885 30.8952 11.7088 30.8952 12.5064C30.8952 13.315 30.9561 13.9464 31.078 14.4005C31.2109 14.8436 31.4546 15.1537 31.809 15.331C32.1746 15.5082 32.7063 15.5968 33.4041 15.5968Z"
        fill="white"
      />
      <rect
        x="1.00024"
        y="1.00006"
        width="44.1538"
        height="22"
        rx="6.38461"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1602_3040"
          x1="14.9944"
          y1="21.3552"
          x2="24.5515"
          y2="-0.556791"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#9B07F6" />
          <stop offset="1" stopColor="#0085FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1602_3040"
          x1="0.225161"
          y1="3.64503"
          x2="17.834"
          y2="33.9144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.131313" stopColor="white" stopOpacity="0.82" />
          <stop offset="0.208333" stopColor="white" />
          <stop offset="0.28125" stopColor="white" stopOpacity="0.78" />
          <stop offset="0.612059" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

export const ProBadgeSvg = React.memo(SvgComponent);
